import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState, type ReactNode } from "react";

import { AuthProvider } from "./auth";
import { RealtimeBridge } from "./realtime";

/** Composition of the app-wide providers: server-state (TanStack Query) and
    auth. The shell wraps its router in this. */
export function AppProviders({ children }: { children: ReactNode }) {
  const [client] = useState(
    () =>
      new QueryClient({
        defaultOptions: { queries: { staleTime: 30_000, retry: 1 } },
      }),
  );
  return (
    <QueryClientProvider client={client}>
      <AuthProvider>
        <RealtimeBridge />
        {children}
      </AuthProvider>
    </QueryClientProvider>
  );
}
